import React from 'react'
import Button from '@/components/StrapiComponents/Button'
import Block from '@/components/StrapiComponents/Block'
import Taglist from '@/components/StrapiComponents/Taglist'
import Bullet from '@/components/StrapiComponents/Bullet'

const StrapiComponents = ({ component, ...rest }) => {
  console.log('>>>component', component)
  console.log('>>>rest', rest)
  switch (component.component) {
    case 'pages.button':
      return <Button component={component} {...rest} />
    case 'pages.content':
      return <Block component={component} {...rest} />
    case 'pages.taglist':
      return <Taglist component={component} {...rest} />
    case 'pages.bullet':
      return <Bullet component={component} {...rest} />
    default:
      break
  }
  return <h2>Here goes a strapi component!</h2>
}

export default StrapiComponents
